import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, errorMessage } from '../../api/client';

const KEY = ['account-settings'] as const;

/** Whether the AI may install custom nodes without asking (doc 34) — only a person can change it. */
export function AiPermissionsPanel() {
  const queryClient = useQueryClient();
  const settings = useQuery({ queryKey: KEY, queryFn: api.accountSettings });
  const save = useMutation({ mutationFn: (value: boolean) => api.saveAccountSettings({ aiInstallsWithoutAsking: value }), onSuccess: (data) => { queryClient.setQueryData(KEY, data); } });
  const value = settings.data?.settings.aiInstallsWithoutAsking ?? false;
  return (
    <section className="panel" aria-labelledby="ai-permissions-title">
      <h2 id="ai-permissions-title">AI permissions</h2>
      <label className="inline-check">
        <input type="checkbox" checked={value} disabled={!settings.isSuccess || save.isPending} onChange={(e) => { save.mutate(e.target.checked); }} />
        Let AI install custom nodes and pickle-format models on my machines without asking
      </label>
      <p className="muted">Off: an AI (Claude via MCP or the workflow tab) can ask for custom nodes, and you approve on the machine page; it downloads only safetensors and GGUF models itself. Custom nodes and pickle models (.ckpt, .pt, .bin) can run code on your computer.</p>
      {[settings.error, save.error].filter(Boolean).map((e, n) => <p key={n} role="alert" className="form-error">{errorMessage(e)}</p>)}
    </section>
  );
}
